import script from "./EditName.vue?vue&type=script&setup=true&lang=js"
export * from "./EditName.vue?vue&type=script&setup=true&lang=js"

import "./EditName.vue?vue&type=style&index=0&id=c5c5d9ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5c5d9ee"]])

export default __exports__